import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import ReactTable from 'react-table'
import { Button, Form, Modal, Popconfirm, Input, Upload, Icon, Tooltip, message } from 'antd'
import Loader from '../../common/Loader'
import { actions } from '../../../redux/modules/jobFunctions/jobAttachmentActions'
import { filterCaseInsensitive } from '../../../util'

const FormItem = Form.Item
const { TextArea } = Input
const propTypes = {}

class JobAttachments extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modalIsShowing: false,
      currentId: 0,
      content: null,
      fileList: []
    }
  }

  componentWillMount() {
    this.props.attachmentsRefresh({
      jobId: this.props.jobId
    })
  }

  showModal = () => {
    this.setState({
      modalVisible: true
    })
  }

  handleRowClick = row => {
    this.setState({
      modalVisible: true,
      currentId: 0,
      content: null
    })
    setTimeout(() => {
      this.setState({
        currentId: row.id,
        content: row
      })
    }, 1)
  }

  handleAddButton = () => {
    this.props.form.resetFields()
    this.setState({
      modalVisible: true,
      currentId: 0,
      content: null,
      fileList: []
    })
  }

  handleCancel = () => {
    this.props.form.resetFields()
    this.setState({ data: [], currentId: 0, modalVisible: false })
  }

  handleCreate = () => {
    const form = this.props.form
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      const { fileList } = this.state
      const formData = new FormData()
      fileList.forEach(file => {
        formData.append('file', file)
      })
      formData.append('jobId', this.props.jobId)
      formData.append('type', 'job')
      formData.append('attachmentId', this.state.currentId)
      formData.append('content', values)
      formData.append('description', values.description)
      formData.append('userId', this.props.user.userId)

      if (this.state.currentId === 0) {
        formData.append('filename', fileList[0].name)

        this.props.createAttachment({
          jobId: this.props.jobId,
          content: values,
          file: formData,
          filename: fileList[0].name,
          userId: this.props.user.userId
        })
        message.warning('Uploading file...')
      } else {
        this.props.updateAttachment({
          jobId: this.props.jobId,
          description: values.description,
          attachmentId: this.state.currentId,
          userId: this.props.user.userId
        })
        message.success('Changes saved.')
      }

      form.resetFields()
      this.setState({ content: null, currentId: 0, modalVisible: false })
    })
  }

  confirmDelete = event => {
    const form = this.props.form

    this.props.deleteAttachment({
      jobId: this.props.jobId,
      attachmentId: this.state.currentId
    })

    form.resetFields()
    message.success('Record deleted.')
    this.setState({
      content: null,
      currentId: 0,
      modalVisible: false
    })
  }

  handleUploadChange = event => {
    console.log('file plesae?', event.target.files)
  }

  render() {
    const { content } = this.state

    const { getFieldDecorator } = this.props.form

    const props = {
      onRemove: file => {
        this.setState(({ fileList }) => {
          const index = fileList.indexOf(file)
          const newFileList = fileList.slice()
          newFileList.splice(index, 1)
          return {
            fileList: newFileList
          }
        })
      },
      beforeUpload: file => {
        this.setState(({ fileList }) => ({
          fileList: [...fileList, file]
        }))
        return false
      },
      fileList: this.state.fileList
    }
    if (!this.props.jobAttachmentActions.attachments) {
      return <Loader />
    }
    return (
      <div>
        <Modal
          visible={this.state.modalVisible}
          title="Attachments"
          okText={content ? 'Save Changes' : 'Create'}
          onCancel={this.handleCancel}
          onOk={this.handleCreate}
          width="90%"
          maskClosable={false}
        >
          <Form layout="vertical">
            {!content && (
              <FormItem label="Files">
                {getFieldDecorator('files', {
                  rules: [
                    {
                      required: !content ? false : true,
                      message: 'FFFF cannot be blank.'
                    }
                  ],
                  initialValue: content ? content.description : ''
                })(
                  <Upload {...props}>
                    <Button>
                      <Icon type="upload" /> Upload
                    </Button>
                  </Upload>
                )}
              </FormItem>
            )}
            <FormItem label="Description">
              {getFieldDecorator('description', {
                rules: [
                  {
                    required: true,
                    message: 'Note description cannot be blank.'
                  }
                ],
                initialValue: content ? content.description : ''
              })(
                <TextArea
                  placeholder="Describe the attachment..."
                  rows={4}
                  initialvalue={content ? content.description : ''}
                />
              )}
            </FormItem>
            <Popconfirm
              title="Are you sure you want to delete this record?"
              onConfirm={this.confirmDelete}
              onCancel={this.cancelDelete}
              okText="Yes"
              cancelText="No"
            >
              {content && <Button type="danger" icon="delete" />}
            </Popconfirm>
          </Form>
        </Modal>
        <div className="jobsBar">
          Attachments
          <div className="jobsBarAdd">
            <i className="fa fa-plus-square" aria-hidden="true" />
            &nbsp;<div onClick={() => this.handleAddButton()} className="addJobLabel">
              ADD Attachment
            </div>
          </div>
        </div>
        {this.props.jobAttachmentActions.attachments && (
          <ReactTable
            filterable
            defaultFilterMethod={filterCaseInsensitive}
            getTdProps={(state, rowInfo, column, instance) => ({
              onClick: e => {
                if (column.Header !== undefined) {
                  this.handleRowClick(rowInfo.original)
                }
              }
            })}
            data={this.props.jobAttachmentActions.attachments.data}
            columns={[
              {
                columns: [
                  {
                    Header: 'Filename',
                    id: 'filename',
                    accessor: 'filename',
                    width: 350,
                    Cell: d => <Tooltip title={d.original.filename}>{d.original.filename}</Tooltip>
                  },
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                    )
                  },
                  {
                    Header: 'Created By',
                    id: 'first_name_created_by',
                    accessor: d => `${d.first_name_created_by} ${d.last_name_created_by}`,
                    maxWidth: 150,
                    Cell: d => {
                      const r = `${d.original.first_name_created_by} ${
                        d.original.last_name_created_by
                      }`
                      return <Tooltip title={r}>{r}</Tooltip>
                    }
                  },
                  {
                    Header: 'Updated By',
                    id: 'first_name_updated_by',
                    accessor: d => `${d.first_name_updated_by} ${d.last_name_updated_by}`,
                    maxWidth: 150,
                    Cell: d => {
                      const r = `${d.original.first_name_updated_by} ${
                        d.original.last_name_updated_by
                      }`
                      return <Tooltip title={r}>{r}</Tooltip>
                    }
                  },
                  {
                    Cell: row => (
                      <Tooltip placement="left" title="Download this file">
                        <a target="_blank" href={row.original.signedUrl}>
                          <Icon type="download" className="fontSize20" />
                        </a>
                      </Tooltip>
                    ),
                    maxWidth: 35
                  }
                ]
              }
            ]}
            defaultPageSize={10}
            className="-striped -highlight"
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = ({ jobAttachmentActions }, ownProps) => ({ jobAttachmentActions })
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(actions, dispatch)
})

JobAttachments.propTypes = propTypes
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Form.create()(JobAttachments))
)



// WEBPACK FOOTER //
// ./src/containers/job/tasks/JobAttachments.js